import React from 'react';
import type { Color } from '../../styles/variables';
import { COLORS } from '../../styles/variables';

interface DotIconProps {
  color?: Color;
  size?: number;
}

const DotIcon: React.FC<DotIconProps> = ({ color = COLORS.black, size = 14 }) => (
  <svg width={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="10" fill={color} />
  </svg>
);

DotIcon.defaultProps = {
  color: undefined,
  size: undefined,
};

export default DotIcon;
